import { useEffect, useState } from 'react';
import CommonSuccessNotification from 'app/ui/components/common-success-notification/CommonSuccessNotification';
import { useAppDispatch, useAppSelector } from 'app/store';
import { RootState } from 'app/store/rootReducer';
import { getMessageByType } from '../config';
import { cleanFlashMessage } from 'app/store/ui';

export default function FlashMessage() {
  const [isVisible, setIsVisible] = useState<number>(0);
  const [message, setMessage] = useState<string>('');

  const { flashMessage } = useAppSelector((state: RootState) => state.ui);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (flashMessage) {
      setMessage(getMessageByType(flashMessage));
      setIsVisible(new Date().getTime());
      dispatch(cleanFlashMessage());
    }
  }, [flashMessage]);

  return <CommonSuccessNotification isOpened={isVisible} mainText={message} />;
}
